import { GridRenderCellParams } from '@mui/x-data-grid/models/params/gridCellParams'
import { GridColDef, GridSingleSelectColDef, GridValueGetter } from '@mui/x-data-grid-premium'
import isEmpty from 'lodash/isEmpty'
import * as React from 'react'
import { isDefined } from '@omnea-app/legacy/utils/type-guard/isDefined'
import { RowGroupingColumnTableCell } from '../../row-grouping/components/RowGroupingColumnTableCell'
import { ROW_GROUPING_NONE_GROUPING_TEXT_VALUE } from '../../row-grouping/helpers'
import { BaseColumnConfig } from '../types'
import { baseColumnConfig } from './baseColumnConfig'
import type { GridValidRowModel } from '@mui/x-data-grid/models/gridRows'

export type CustomRenderColumnConfig<T extends GridValidRowModel, V = any> = BaseColumnConfig<T, 'custom-render'> & {
  columnType: 'custom-render'
  valueGetter: GridValueGetter<T, V>
  renderCell: (params: GridRenderCellParams<T, V>) => React.ReactNode
  type?: GridColDef<T, V>['type']
  editable?: boolean
  groupingValueGetter?: GridColDef<T, V>['groupingValueGetter']
  filterable?: boolean
  valueOptions?: GridSingleSelectColDef['valueOptions']
}

export const getCustomRenderColumn = <T extends GridValidRowModel>({
  style,
  ...config
}: CustomRenderColumnConfig<T>): GridColDef<T> => ({
  ...baseColumnConfig,
  ...style,
  ...config,
  groupingValueGetter: config.groupingValueGetter ?? config.valueGetter,
  renderCell: (params) => {
    if (!isDefined(params.value)) return null
    if (params.rowNode.type === 'group') {
      return (
        <RowGroupingColumnTableCell
          columnHeaderName={config.headerName}
          value={!isEmpty(params.value) ? params.value : ROW_GROUPING_NONE_GROUPING_TEXT_VALUE}
          id={params.id}
        />
      )
    }
    return config.renderCell(params)
  },
})
